// extracted by mini-css-extract-plugin
export var errorIcon = "_qa-1";
export var nameLogo = "_qa-0";